module.exports = __webpack_public_path__ + "static/day01-6d0a17d55a77766820dab71b85446666.png";